// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1Hkxr","content":"GlobalSearch_content__3SbWR"};